import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { getO2NewSkin, ThemeConfig, ThemeContextProvider } from '@telefonica/mistica';
import '@telefonica/mistica/css/mistica.css';
import { Provider } from 'react-redux';
import { store } from './utils/store/store';
import { BrowserRouter as Router } from 'react-router-dom';
import GlobalLoader from './utils/globals/GlobalLoader';
import GlobalError from './utils/globals/GlobalError';
import { GlobalContext } from './utils/globals/GlobalContext';
import GlobalSnackbar from './utils/globals/GlobalSnackbar';
import GlobalStopper from './utils/globals/GlobalStopper';
import GlobalSnackbarProfile from './utils/globals/GlobalSnackbarProfile';
import BillsProvider from './utils/store/context/bills-context/BillsProvider';
import ConfigureLineProvider from './utils/store/context/configure-line-context/ConfigureLineProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import PersonalDataProvider from './utils/store/context/personal-data-context/PersonalDataProvider';
import MobileLinesProvider from './utils/store/context/mobile-lines-context/MobileLinesProvider';

const LOCALE = 'es-ES';
const LOCALE_REGION = 'ES';
const misticaTheme: ThemeConfig = {
    skin: getO2NewSkin(),
    colorScheme: 'light',
    i18n: { locale: LOCALE, phoneNumberFormattingRegionCode: LOCALE_REGION },
};
const root = document.getElementById('root');

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            cacheTime: 900000,
            staleTime: 300000,
            refetchOnWindowFocus: false,
            retry: 0,
        },
    },
});

ReactDOM.render(
    <ThemeContextProvider theme={misticaTheme}>
        <Provider store={store}>
            <Router>
                <GlobalError />
                <GlobalLoader />
                <GlobalStopper />
                <GlobalContext>
                    <QueryClientProvider client={queryClient}>
                        <MobileLinesProvider>
                            <PersonalDataProvider>
                                <ConfigureLineProvider>
                                    <BillsProvider>
                                        <App />
                                        <GlobalSnackbar />
                                        <GlobalSnackbarProfile />
                                    </BillsProvider>
                                </ConfigureLineProvider>
                            </PersonalDataProvider>
                        </MobileLinesProvider>
                    </QueryClientProvider>
                </GlobalContext>
            </Router>
        </Provider>
    </ThemeContextProvider>,
    root,
);

reportWebVitals();
